import React        from 'react';
import Parse        from 'parse';
import Utils        from '../Utils/Utility';
// import SimpleButton from '../generic/simple-button';

const FORGOT_PASSWORD        = "Forgot password ?";
const RESET_PASSWORD         = "Reset Password";
const LOGIN_BUTTON_TEXT      = "Login";
let logoSrc = require('../../img/freshbytes-logo.png');


export default class ForgotPasswordComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error                  : null,
            // isProcessActive        : false,
            isPasswordResetReqSent : false
        };
    }

    componentDidMount() {
        // this.fusername.focus();
    }

    handleChange(){
        this.setState({
            error: ""
        })
    }

    submitResetPassword = (e) => {
        e.preventDefault();
        const email = this.refs.email.value;

        if(!Utils.isEmpty(email)){
            Parse.User.requestPasswordReset(email)
                .then(
                    (success) => {
                        console.log(success);
                        this.setState({
                            isPasswordResetReqSent : true
                        });
                    },
                    (error) => {
                        console.log(JSON.stringify(error));
                        this.setState({
                            error                  : error.message,
                            isPasswordResetReqSent : false
                        });
                    }
                );
        }else{
            this.setState({
                error    : "Please enter the valid email",
            });

            return;
        }




    }

    render() {
        const logoCommonStyle
            = {
            maxWidth     : '50%',
            height       : 'auto',
            maxHeight       : '100px',
            marginTop : '15px'
        };
        return (
            <div id="forgotbox" className="mainbox col-md-offset-3 col-md-6 col-sm-12">
                <h1 className={"header-text"} style={{textAlign:'center', fontWeight: "600"}}>
                    Forgot Password?
                </h1>
                <div className="panel col-center-block login-container mt-30 text-center">
                    {/*<img*/}
                        {/*className="img-responsive center-block"*/}
                        {/*style={logoCommonStyle}*/}
                        {/*alt="FreshBytes"*/}
                        {/*title="FreshBytes"*/}
                        {/*src={logoSrc}*/}
                    {/*/>*/}
                    <div style={{padding: "0 15px 0"}} className="panel-body">


                        {
                            !this.state.isPasswordResetReqSent
                                ? (
                                    <div className={""}>
                                        <form id="passwordResetform" className="form-horizontal" role="form"
                                              onSubmit={this.submitResetPassword}>

                                            <div className="form-group mb-0">
                                            {/*<span className="input-group-addon">*/}
                                                {/*<i className="glyphicon glyphicon-user"></i>*/}
                                            {/*</span>*/}
                                                <label
                                                    id        =  "email"
                                                    className =  {"text-white forgot-pass-text pull-left"}
                                                    style     =  {{letterSpacing: "2px", fontWeight: "500"}}
                                                    // style={{margin: "0 auto"}}
                                                >
                                                    Email Address
                                                </label>
                                                <input
                                                    ref = "email"
                                                    aria-labelledby = "email"
                                                    id="login-username"
                                                    type="email"
                                                    className="form-control forgot-pass-text"
                                                    name="username"
                                                    // placeholder="Enter email address"
                                                    onChange={this.handleChange.bind(this)}
                                                />

                                                {!Utils.isEmpty(this.state.error) ? (
                                                    <div className="forgot-error-container form-text" style={{color: "red"}}>
                                                        <i className="fa fa-warning" style={{color: "white"}} aria-hidden="true"></i>
                                                        <span className="ml-5 text-white forgot-pass-text">{this.state.error}</span>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="form-group text-center">
                                                <div className="col-sm-12 controls mt-10">
                                                    <button
                                                        className="btn forgot-pass"
                                                        // id="btn-reset"
                                                        type="submit"
                                                    >
                                                        {RESET_PASSWORD}
                                                    </button>
                                                </div>
                                            </div>


                                            <div className="panel-heading text-center" style={{ marginTop:'15px', marginBottom: "8px"}}>
                                                <div className="forgot-pass-text" style={{fontSize: '16px'}}>
                                                    <a href="JavaScript:void(0)" style={{color: "#fff"}} onClick={this.props.showLoginBox}>Return to sign in</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )
                                : (
                                    <div>
                                        <div className="form-group">
                                            <div className="col-xs-12 mb-10">
                                                <span className="forgot-pass-text text-white mb-20" style={{fontSize: 16}}>
                                                    Please check your inbox
                                                    to reset your password,
                                                    then login.
                                                </span>
                                            </div>
                                        </div>
                                        <br/>

                                        <div style={{marginTop: 10}} className="form-group">
                                            <div className="col-sm-12 controls mt-20">
                                                <button
                                                    // id="btn-reset"
                                                    type='btn'
                                                    className="btn forgot-login"
                                                    onClick={this.props.showLoginBox}
                                                    id="btn-login"
                                                >
                                                    {LOGIN_BUTTON_TEXT}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/forgot-password.jsx